import { render, staticRenderFns } from "./BookingTalentListItem.vue?vue&type=template&id=72e7c220&scoped=true"
import script from "./BookingTalentListItem.vue?vue&type=script&lang=js"
export * from "./BookingTalentListItem.vue?vue&type=script&lang=js"
import style0 from "./BookingTalentListItem.vue?vue&type=style&index=0&id=72e7c220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7c220",
  null
  
)

export default component.exports